module.exports = __webpack_public_path__ + "4cff2b39e93c8cef6ed63d8bba51b9cb.jpg";